<div class="formContainer">

    <div class="form-header-background">
      <div class="form-title-parent-div">
        <h1 class="form-title">
          340B Entity Verification Form
        </h1>
      </div>
      <div class="form-close-parent-div">
        <fa-icon class="glyphicon glyphicon-question-sign cur-pntr" (click)="closeForm()" style="font-size: 30px;" [icon]="faTimes"></fa-icon>
      </div>
    </div>
  
  
  <div class="form-intro">
    Dear Provider,<br/>
    To request access to 340B Drug Discount Pricing please complete all the information requested below and submit for eligibility verification.
  </div>
  <h2 class="form-info"> Please provide the following Information</h2>
  <div class="form-body">
    <form [formGroup]="entityVerificationForm340B">
        <div>
          <p class="form-initial-details"> <strong>Customer Name (Hospital Name):</strong> {{entityVerificationForm340B.get('customerName').value}}</p>
          <br/>
          <p class="form-initial-details"> <strong>Customer "Ship to" 10 digit Number:</strong> {{entityVerificationForm340B.get('customerShipToNum').value}}</p>
          <p class="form-initial-details" style="margin-left: 2%;"> <strong>"Ship to" Address:</strong> {{entityVerificationForm340B.get('prodShiptoAddress').value}}, {{entityVerificationForm340B.get('prodShiptoCity').value}}, {{entityVerificationForm340B.get('prodShiptoState').value}}, {{entityVerificationForm340B.get('prodShiptoZip').value}}</p>
        </div>
        <div>
          <div class="form-row">
            <div style="width: 20%;" class="details-340B form-group">
              <label for="id" class="required">340B ID Number</label>
              <input id="id" class="form-control" formControlName="id"
              [ngClass]="{ 'is-invalid': submitted && f.id.errors }">
              <p>(as listed on HRSA site)</p>
              <div *ngIf="submitted && f.id.errors" class="invalid-feedback">
                <div *ngIf="f.id.errors.required">340B ID Number is required</div>
              </div>
            </div>
            <div style="width: 30%;" class="details-340B form-group">
              <label for="hospital340BAdministratorName" class="required">Hospital 340B Administrator Name</label>
              <input id="hospital340BAdministratorName flex-width" class="form-control form-input" formControlName="hospital340BAdministratorName"
              [ngClass]="{ 'is-invalid': submitted && f.hospital340BAdministratorName.errors }">
              <div *ngIf="submitted && f.hospital340BAdministratorName.errors" class="invalid-feedback">
                <div *ngIf="f.hospital340BAdministratorName.errors.required">Hospital 340B Administrator Name is required</div>
              </div>
            </div>
            <div style="width: 50%;" class="details-340B form-group">  
              <label for="hospital340BAdministratorEmail" class="required">Hospital 340B Administrator Email Address</label>
              <input id="hospital340BAdministratorEmail flex-width" class="form-control form-input" formControlName="hospital340BAdministratorEmail"
              [ngClass]="{ 'is-invalid': submitted && f.hospital340BAdministratorEmail.errors }">
              <div *ngIf="submitted && f.hospital340BAdministratorEmail.errors" class="invalid-feedback">
                <div *ngIf="f.hospital340BAdministratorEmail.errors.required">Hospital 340B Administrator Email Address is required</div>
                <div *ngIf="f.hospital340BAdministratorEmail.invalid && !f.hospital340BAdministratorEmail.errors.required">Email address is invalid</div>
              </div>
            </div>
          </div>
          <br/>
          <div class="form-row">
            <div style="width: 25%;" class="bill-container form-group">
              <label for="hospitalBillNumber" class="required">Customer "Bill to" 10-digit Number</label>
              <input id="hospitalBillNumber" class="form-control form-input " formControlName="hospitalBillNumber"
              [ngClass]="{ 'is-invalid': submitted && f.hospitalBillNumber.errors }">
              <div><fa-icon class="glyphicon glyphicon-question-sign cur-pntr icon-postion"            
              (mouseenter) = "onMouseEnterShowToolTip()" (mouseleave)="onMouseleave()"
              [icon]="faQuestionCircle" ></fa-icon></div>
              <p>(starting with 3000)</p>
              <div *ngIf="showImage">
                <img
                              class="tooltip-entity-verification"
                              src="assets/images/BilltoHover.png"
                              alt=""
                            />
              </div>
              <div *ngIf="submitted && f.hospitalBillNumber.errors" class="invalid-feedback">
                <div *ngIf="f.hospitalBillNumber.errors.required">Customer Bill Number is required</div>                
              </div>
            </div>
            <div style="width: 23%;" class="address-details form-group">
              <label for="productBillToAddress" class="required">Product "Bill to" Address Street</label>
              <input id="productBillToAddress"   class="form-control form-input" formControlName="productBillToAddress"
              [ngClass]="{ 'is-invalid': submitted && f.productBillToAddress.errors }">
              <div *ngIf="submitted && f.productBillToAddress.errors" class="invalid-feedback">
                <div *ngIf="f.productBillToAddress.errors.required">Product Bill Street Address is required</div>                
              </div>
            </div>
            <div style="width: 22%;" class="address-details form-group">
              <label for="city" class="required">City</label>
              <input id="city" class="form-control form-input" formControlName="city"
              [ngClass]="{ 'is-invalid': submitted && f.city.errors }">
              <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
                <div *ngIf="f.city.errors.required">City is required</div>                
              </div>
            </div>
            <div  style="width: 20%;" class="address-details form-group">
              <label for="state" class="required">State</label>
              <input id="state" class="form-control form-input" formControlName="state"
              [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
              <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
                <div *ngIf="f.state.errors.required">State is required</div>                
              </div>
            </div>
            <div style="width: 10%;" class="address-details form-group">
              <label for="zip" class="required">Zip</label>
              <input id="zip" class="form-control form-input" formControlName="zip"
              [ngClass]="{ 'is-invalid': submitted && f.zip.errors }">
              <div *ngIf="submitted && f.zip.errors" class="invalid-feedback">
                <div *ngIf="f.zip.errors.required">Zip is required</div>                
              </div>
            </div>
      
          </div>
        </div>
        <br/>
        <div class="form-pharmacy-details">
            <p><strong> Cardinal Health Nuclear Pharmacy Name/Number: </strong>{{entityVerificationForm340B.get('pharmacyName').value}} - {{entityVerificationForm340B.get('locationNum').value}}</p>
        </div>
    </form>
  </div>
  
  <div class="footer">  
    <fa-icon class="glyphicon glyphicon-question-sign cur-pntr" [icon]="faInfoCircle"></fa-icon>
    <span style="color: #979797;">  Clicking on SUBMIT will send an email containing the above information to the CAH. 340B email address <strong>{{nuctrac340BEmailInquires}}</strong>;. After the form has been submitted in the next screen you will have the opportunity to print the form or send it to additional email addresses.</span>
   <br/> If you and the 340B administrator do not receive an auto-email about this submission within (10 mins) please submit this form again.
    Once the form is submitted successfully you will be notified of eligibility as soon as possible, every attempt is made to complete this task within 2 business days.
  </div>
  
      <button
      type="button"
      name="button"
      class="button-cancel"
      (click)="closeForm()"
      >
      Cancel
      </button>
  
      <button
      type="button"
      name="button"
      class="button-submit"
      (click)="submitForm()"
      >
      Submit
      </button>
</div>

<!-- 340B Entity verification PDF to view pdf content in webpage remove height" -->
<div style="height: 0 !important;">  
  <entity-verification-pdf [entityFormData]="formData" [pdfType]="pdfType"></entity-verification-pdf> 
</div>
  
  
  